<template>
  <router-link
    :to="{ name: 'Post', params: { slug: post.slug }}"
    class="c-nav-news u-show@tablet"
    :class="'c-nav-news__' + position"
  >

    <div class="c-nav-news__info" :class="position === 'right' ? 'u-flex-row-reverse' : ''">
      <h2 class="c-nav-news__title">
        {{ post.title | truncate(50)}}
      </h2>

      <figure class="c-nav-news__image" v-if="post.imageUrl">
        <img :src="post.imageUrl"/>
      </figure>
    </div>

    <button>
      <i class="u-icon">arrow_{{position}}</i>
    </button>
  </router-link>
</template>

<script>
export default {
  props: {
    position: String,
    post: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/app/screens/Post/components/NavPost.vue